import * as React from 'react';
import { Route, Routes } from 'react-router-dom';
import * as Page from './sections';

type AppRoute = {
    id: string,
    path: string,
    area: string,
    wrapperElement: JSX.Element,
    children?: AppRoute[]
}

const AppRoutes: AppRoute[] = [
    {
        id: "Home",
        path: '/',
        area: "",
        wrapperElement: <Page.HomePage />
    },
    {
        id: "Mahjong",
        path: '/mahjong',
        area: "mahjong",
        wrapperElement: <Page.MahjongManager />,
        children: [
            { id: "Mahjong Index", path: "", area: "mahjong", wrapperElement: <Page.MahjongManagerIndex /> },
            { id: "Mahjong Game Test", path: 'GameTest', area: "mahjong", wrapperElement: <Page.GameTest /> },
            { id: "Tile Set", path: 'tileset', area: "data", wrapperElement: <Page.TileSetDisplay /> },
            { id: "Yaku List", path: 'yaku', area: "data", wrapperElement: <Page.YakuList /> }
        ]
    },
    {
        id: "Data",
        path: '/data',
        area: "data",
        wrapperElement: <Page.DataManager />,
        children: [
            { id: "Data Index", path: "", area: "data", wrapperElement: <Page.DataManagerIndex /> },
            { id: "Draw Steel Sourcebooks", path: 'draw-steel-sourcebooks', area: "data", wrapperElement: <Page.DrawSteelSourcebooks /> }
        ]
    },
    {
        id: "User",
        path: '/user',
        area: "user",
        wrapperElement: <Page.UserManager />,
        children: [
            { id: "User Profile", path: 'profile', area: "user", wrapperElement: <Page.UserProfile /> }
        ]
    },
    {
        id: "Account Locked",
        path: '/error',
        area: "error",
        wrapperElement: <Page.ErrorManager />,
        children: [
            { id: "Account Locked", path: "account-locked", area: "error", wrapperElement: <Page.AccountLocked /> }
        ]
    },
];

export function AppRouter(): JSX.Element {
    const renderRoutes = (routes: AppRoute[]) => {
        return routes.map((route: AppRoute, index: number) => (
            <Route key={index} path={route.path} element={route.wrapperElement}>
                {route.children && renderRoutes(route.children)}
            </Route>
        ));
    };

    return (
        <Routes>
            {renderRoutes(AppRoutes)}
            <Route path="*" element={<Page.NotFound />} />
        </Routes>
    );
}
